/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef, type Ref } from 'react';
import IconButton from '@atlaskit/button/icon/button';
import type { CommonNavMenuButtonProps } from './types.tsx';

export const CommonNavMenuButton: React.ForwardRefExoticComponent<
	CommonNavMenuButtonProps & React.RefAttributes<HTMLButtonElement>
> = forwardRef(
	({ onClick, icon, ...props }: CommonNavMenuButtonProps, ref: Ref<HTMLButtonElement>) => {
		return (
			<IconButton
				{...props}
				icon={icon}
				onClick={onClick}
				ref={ref}
				spacing="compact"
				appearance="subtle"
			/>
		);
	},
);
